import { useEffect, useState } from 'react';

import { type FormField, formFieldPresentation } from '@/components/shared/form/form-fields';
import { TextInput } from '@/components/ui/form/text-input';
import { MutedText } from '@/components/ui/typography';

export function NameSeparateField({
  id,
  field,
  value,
  disabled,
  onChange,
}: {
  id: string;
  field: FormField;
  value: string;
  disabled: boolean;
  onChange: (val: string) => void;
}) {
  const spaceIdx = value.indexOf(' ');
  const [first, setFirst] = useState(spaceIdx >= 0 ? value.slice(0, spaceIdx) : value);
  const [last, setLast] = useState(spaceIdx >= 0 ? value.slice(spaceIdx + 1) : '');
  const presentation = formFieldPresentation(field);

  useEffect(() => {
    if (value === '') {
      setFirst('');
      setLast('');
    }
  }, [value]);

  const update = (f: string, l: string) => {
    setFirst(f);
    setLast(l);
    onChange([f, l].filter(Boolean).join(' '));
  };

  return (
    <div className="grid gap-1.5">
      <div className="grid grid-cols-2 gap-4">
        <TextInput
          id={`${id}-first-name`}
          label={field.firstNameLabel ?? 'First Name'}
          isRequired={field.required}
          showAsterisk={presentation.showAsterisk}
          placeholder={field.firstNamePlaceholder}
          value={first}
          onChange={(e) => update(e.target.value, last)}
          disabled={disabled}
          required={field.required}
        />
        <TextInput
          id={`${id}-last-name`}
          label={field.lastNameLabel ?? 'Last Name'}
          isRequired={field.required}
          showAsterisk={presentation.showAsterisk}
          placeholder={field.lastNamePlaceholder}
          value={last}
          onChange={(e) => update(first, e.target.value)}
          disabled={disabled}
          required={field.required}
        />
      </div>
      {presentation.helperText ? (
        <MutedText data-slot="form-field-helper" className="text-xs">
          {presentation.helperText}
        </MutedText>
      ) : null}
    </div>
  );
}
